import { useState } from "react";
import { Panel } from "@/pages/Company/Dashboard/DashboardPage";

interface GrafanaIframeProps {
	panelNumber: Panel;
	companyId: number;
	width: number;
	height: number;
	selectedRange: {
		from: Temporal.PlainDate | undefined;
		to: Temporal.PlainDate | undefined;
	};
	queryToken: string;
}

export function GrafanaPanel({
	panelNumber,
	width,
	height,
	selectedRange: { from, to },
	queryToken,
	companyId,
}: GrafanaIframeProps) {
	const [isTable, setIsTable] = useState(false);

	return (
		<div
			className="grafanaPanel"
			style={{
				width: width - 8,
				height: height - 8,
			}}
		>
			<div className="toggleTablePanel" onClick={() => setIsTable(!isTable)}>
				<input
					type="checkbox"
					id={`toggleTablePanel-${panelNumber}`}
					checked={isTable}
				/>
				<label htmlFor={`toggleTablePanel-${panelNumber}`} />
			</div>
			<iframe
				style={
					!isTable
						? undefined
						: {
								opacity: 0,
								pointerEvents: "none",
							}
				}
				src={`https://grafana.huellacarbono.cluster.pre5.wundersolutions.es/d-solo/adf66n9/aeiriojav2?orgId=1${from ? `&from=${from.toPlainDateTime(Temporal.PlainTime.from("00:00:00"))}` : ""}${to ? `&to=${to.toPlainDateTime(Temporal.PlainTime.from("00:00:00"))}` : ""}&timezone=browser&var-idEmpresa=${companyId}&tab=queries&showCategory=Axis&theme=light&panelId=panel-${isNaN(panelNumber) ? panelNumber.idPanelDashboard : panelNumber}&__feature.dashboardSceneSolo=true&auth_token=${queryToken}`}
			/>
			<iframe
				style={
					isTable
						? undefined
						: {
								opacity: 0,
								pointerEvents: "none",
							}
				}
				src={`https://grafana.huellacarbono.cluster.pre5.wundersolutions.es/d-solo/adf66n9/aeiriojav2?orgId=1${from ? `&from=${from.toPlainDateTime(Temporal.PlainTime.from("00:00:00"))}` : ""}${to ? `&to=${to.toPlainDateTime(Temporal.PlainTime.from("00:00:00"))}` : ""}&timezone=browser&var-idEmpresa=${companyId}&tab=queries&showCategory=Axis&theme=light&panelId=panel-${isNaN(panelNumber) ? panelNumber.idPanelTable : panelNumber}&__feature.dashboardSceneSolo=true&auth_token=${queryToken}`}
			/>
		</div>
	);
}
